export const DELETE_CONFIRMATION = "Are you sure you want to permanently delete - "
export const ALERT = "Alert";
